import PropTypes from "prop-types";
import Skeleton from "react-loading-skeleton";
import styles from "./styles/gallery.module.css";
import { Media } from "./Media";

export function Gallery({ title, media }) {
  if (!media) {
    return (
      <div className={styles.container}>
        <div className={styles.innerContainer}>
          <Skeleton height="100vh" width="100vw" />
        </div>
      </div>
    );
  }
  return (
    <div className={styles.container}>
      <div className={styles.innerContainer}>
        {media.map((mediaSrc, index) => (
          <Media src={mediaSrc} key={mediaSrc.id} title={title} index={index} />
        ))}
      </div>
    </div>
  );
}

Gallery.propTypes = { title: PropTypes.string.isRequired, mediaList: PropTypes.array };
